<template>
  <router-view />
</template>

<script>
export default {
  name: 'Commande'
};
</script>
